<script setup lang="ts">
import { useRoute } from 'vue-router'

import { BoxComponent, ButtonComponent, FlexComponent, TypographyComponent } from '@/ui-library'

const route = useRoute()
</script>

<template>
  <FlexComponent direction="column" align="center" justify="center" :style="{ minHeight: '100vh', padding: '24px' }">
    <BoxComponent :p="48" :max-w="600">
      <FlexComponent direction="column" align="center" :gap="24">
        <TypographyComponent variant="body-large" text-align="center">
          <template v-if="route.query.reason === 'banned'">
            It seems like you have lost access to our app. Please contact <a href="mailto:support@metapic.com">support@metapic.com</a>
          </template>
          <template v-else> You don't have access to this page. </template>
        </TypographyComponent>
        <ButtonComponent href="/logout"> Logout </ButtonComponent>
      </FlexComponent>
    </BoxComponent>
  </FlexComponent>
</template>
